import { render, staticRenderFns } from "./SentFollowupEmails.vue?vue&type=template&id=5ee7a8fc&scoped=true"
import script from "./SentFollowupEmails.vue?vue&type=script&lang=js"
export * from "./SentFollowupEmails.vue?vue&type=script&lang=js"
import style0 from "./SentFollowupEmails.vue?vue&type=style&index=0&id=5ee7a8fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee7a8fc",
  null
  
)

export default component.exports